// eslint-disable-next-line no-restricted-imports
import {Breadcrumb as DIGBreadcrumb} from '@dropbox/dig-components/breadcrumb';
import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import type {ComponentProps} from 'react';

import {Link, LinkProps} from './Link';

type DIGBreadcrumbLinkProps = ComponentProps<typeof DIGBreadcrumb.Link>;

export type BreadcrumbLinkProps = Omit<DIGBreadcrumbLinkProps, 'href'> & LinkProps;

// This seems to not work. Maybe something about a ref not being passed from <DIGBreadcrumb.Link> to <Link>?
const BreadcrumbLink = ({
  withLeftIcon,
  withMenuItemIcon,
  isCurrentPath,
  children,
  ...props
}: BreadcrumbLinkProps) => (
  // eslint-disable-next-line no-restricted-syntax
  <DIGBreadcrumb.Link
    isCurrentPath={isCurrentPath}
    withLeftIcon={withLeftIcon}
    withMenuItemIcon={withMenuItemIcon}
    onClick={(e) => e.preventDefault()}
  >
    <Link {...props} to={props.to} hasNoUnderline monochromatic>
      {children}
    </Link>
  </DIGBreadcrumb.Link>
);

const breadcrumbLinkBuilder = (breadcrumbs: BreadcrumbLinkProps[]) =>
  breadcrumbs.map((breadcrumb, index) => (
    <DIGBreadcrumb.Link
      key={`breadcrumb__${breadcrumb.to.toString()}__${index}`}
      isCurrentPath={index === breadcrumbs.length - 1}
      withLeftIcon={breadcrumb.withLeftIcon}
      withMenuItemIcon={breadcrumb.withMenuItemIcon}
      onClick={(e) => e.preventDefault()}
    >
      <Link {...breadcrumb} to={breadcrumb.to} hasNoUnderline monochromatic>
        <Truncate maxWidth={400} tooltipControlProps={{placement: 'bottom'}}>
          {index === breadcrumbs.length - 1 ? (
            <Text color="subtle" isBold>
              {breadcrumb.children}
            </Text>
          ) : (
            breadcrumb.children
          )}
        </Truncate>
      </Link>
    </DIGBreadcrumb.Link>
  ));

const Breadcrumb = ({
  path,
  withMarginBottom = true,
}: {
  path: BreadcrumbLinkProps[];
  withMarginBottom?: boolean;
}) => (
  <DIGBreadcrumb
    linksDisplayed={3}
    typography="text"
    size="medium"
    isRootOverflow={false}
    className={withMarginBottom ? atoms({marginBottom: '36'}) : undefined}
  >
    {breadcrumbLinkBuilder(path)}
  </DIGBreadcrumb>
);

export {Breadcrumb, BreadcrumbLink, breadcrumbLinkBuilder, DIGBreadcrumb};
